export enum LoyaltyAsset {
  HOURGLASS = 'hourglass',
  HOURGLASS_ALT = 'hourglass-alt',
  CHEWY_MEGAPHONE = 'chewy-megaphone',
  CHEWY_MEGAPHONE_ALT = 'chewy-megaphone-alt',
  EXPIRING_REWARDS = 'expiring-rewards',
  MEO_COMING_SOON = 'meo-coming-soon',
  MEO_COMING_SOON_ALT = 'meo-coming-soon-alt',
  LEFT_QUOTE = 'left-quote',
  LEFT_QUOTE_ALT = 'left-quote-alt',
  PET_HIGH_FIVE = 'pet-high-five',
  PET_HIGH_FIVE_ALT = 'pet-high-five-alt',
  PET_HIGH_FIVE_ALT_CONTRAST = 'pet-high-five-alt-contrast',
  PET_HIGH_FIVE_ACCENT = 'pet-high-five-accent',
  PET_HIGH_FIVE_ACCENT_ALT = 'pet-high-five-accent-alt',
  RIGHT_QUOTE = 'right-quote',
  RIGHT_QUOTE_ALT = 'right-quote-alt',
  THREE_PLUSES = 'three-pluses',
  THREE_PLUSES_ALT = 'three-pluses-alt',
  THREE_PLUSES_ALT_CONTRAST = 'three-pluses-alt-contrast',
  SIGN_UP_HERO_DOG = 'sign-up-hero-dog',
  SIGN_UP_HERO_DOG_ALT = 'sign-up-hero-dog-alt',
  SIGN_UP_HERO_CAT = 'sign-up-hero-cat',
  SIGN_UP_HERO_CAT_ALT = 'sign-up-hero-cat-alt',
  SIGN_UP_HERO_DOG_HOLIDAY = 'sign-up-hero-dog-holiday',
  SIGN_UP_V4_BENEFIT_ICON = 'sign-up-v4-benefit-icon',
  SIGN_UP_V4_PEEK_TAGLINE = 'sign-up-v4-peek-tagline',
  SIGN_UP_V4_PEEK_TAGLINE_DARK = 'sign-up-v4-peek-tagline-dark',
  SIGN_UP_V4_HERO_MOBILE = 'sign-up-v4-hero-mobile',
  SIGN_UP_V4_HERO_MOBILE_DARK = 'sign-up-v4-hero-mobile-dark',
  SIGN_UP_V4_HERO_TABLET = 'sign-up-v4-hero-tablet',
  SIGN_UP_V4_HERO_DESKTOP = 'sign-up-v4-hero-desktop',
  SIGN_UP_V4_HERO_DESKTOP_DARK = 'sign-up-v4-hero-desktop-dark',
  SIGN_UP_V4_HERO_MOBILE_DOODLE = 'sign-up-v4-hero-mobile-doodle',
  SIGN_UP_V4_PEEK_ARROW = 'sign-up-v4-peek-arrow',
  SIGN_UP_V4_PEEK_ARROW_DARK = 'sign-up-v4-peek-arrow-dark',
  SIGN_UP_V4_ROI_FOOD = 'sign-up-v4-roi-food',
  SIGN_UP_V4_ROI_FOOD_DARK = 'sign-up-v4-roi-food-dark',
  SIGN_UP_V4_ROI_SHIPPING = 'sign-up-v4-roi-shipping',
  SIGN_UP_V4_ROI_SHIPPING_DARK = 'sign-up-v4-roi-shipping-dark',
  SIGN_UP_V4_ROI_HEALTH = 'sign-up-v4-roi-health',
  SIGN_UP_V4_ROI_HEALTH_DARK = 'sign-up-v4-roi-health-dark',
  SIGN_UP_V4_ROI_RX = 'sign-up-v4-roi-rx',
  SIGN_UP_V4_ROI_RX_DARK = 'sign-up-v4-roi-rx-dark',
  SIGN_UP_V4_ROI_GENERAL = 'sign-up-v4-roi-general',
  SIGN_UP_V4_ROI_GENERAL_DARK = 'sign-up-v4-roi-general-dark',
  SIGN_UP_V4_ROI_CLOUD = 'sign-up-v4-roi-cloud',
  SIGN_UP_V4_ROI_CLOUD_DARK = 'sign-up-v4-roi-cloud-dark',
  TESTIMONIAL_CAROUSEL_DOG = 'testimonial-carousel-dog',
  TESTIMONIAL_CAROUSEL_DOG_ALT = 'testimonial-carousel-dog-alt',
  TESTIMONIAL_CAROUSEL_CAT = 'testimonial-carousel-cat',
  TESTIMONIAL_CAROUSEL_CAT_ALT = 'testimonial-carousel-cat-alt',
  FAQ_QUOTES_LIGHT = 'faq-quotes-light',
  FAQ_QUOTES_DARK = 'faq-quotes-dark',
}

export const LoyaltyAssetMap: Record<LoyaltyAsset, string> = {
  [LoyaltyAsset.HOURGLASS]:
    'https://image.chewy.com/catalog/cms/logos/attribute-icons/0685b138-3fcb-7ab4-8000-46c1810d8aa5.svg',
  [LoyaltyAsset.HOURGLASS_ALT]:
    'https://image.chewy.com/catalog/cms/logos/attribute-icons/068e6765-756a-72dd-8000-bfdd840b0b4b.svg',
  [LoyaltyAsset.CHEWY_MEGAPHONE]:
    'https://image.chewy.com/catalog/cms/logos/attribute-icons/0687805b-2f31-7eb3-8000-b507ddbcf235.svg',
  [LoyaltyAsset.CHEWY_MEGAPHONE_ALT]:
    'https://image.chewy.com/catalog/cms/logos/attribute-icons/068e6765-2a7e-75d7-8000-25a706499a1c.svg',
  [LoyaltyAsset.EXPIRING_REWARDS]:
    'https://image.chewy.com/catalog/cms/logos/attribute-icons/06ab5fb6-9a54-7e8a-8000-231832fcfc3d.svg',
  [LoyaltyAsset.MEO_COMING_SOON_ALT]:
    'https://image.chewy.com/catalog/cms/logos/attribute-icons/068f2d0d-65ac-7aaa-8000-10f5486c69b1.svg',
  [LoyaltyAsset.MEO_COMING_SOON]:
    'https://image.chewy.com/catalog/cms/logos/attribute-icons/068f2d0d-7073-7078-8000-8f6323d128a2.svg',
  [LoyaltyAsset.LEFT_QUOTE]:
    'https://image.chewy.com/catalog/cms/logos/attribute-icons/068f5334-2170-7a16-8000-c046175159df.svg',
  [LoyaltyAsset.LEFT_QUOTE_ALT]:
    'https://image.chewy.com/catalog/cms/logos/attribute-icons/068f534e-2ae8-7787-8000-09f9e5b70ce8.svg',
  [LoyaltyAsset.RIGHT_QUOTE]:
    'https://image.chewy.com/catalog/cms/logos/attribute-icons/068f5334-4b71-749a-8000-328668752014.svg',
  [LoyaltyAsset.RIGHT_QUOTE_ALT]:
    'https://image.chewy.com/catalog/cms/logos/attribute-icons/068f534e-35af-7431-8000-e84a1325e02d.svg',
  [LoyaltyAsset.PET_HIGH_FIVE]:
    'https://image.chewy.com/catalog/cms/logos/attribute-icons/0685ee2e-28f1-730a-8000-7c4379fa10bd.svg',
  [LoyaltyAsset.PET_HIGH_FIVE_ALT]:
    'https://image.chewy.com/catalog/cms/logos/attribute-icons/068e6765-5542-7511-8000-6c948dee4fb7.svg',
  [LoyaltyAsset.PET_HIGH_FIVE_ALT_CONTRAST]:
    'https://image.chewy.com/catalog/cms/logos/attribute-icons/068f1644-1c40-7a80-8000-be8cb2a31762.svg',
  [LoyaltyAsset.PET_HIGH_FIVE_ACCENT]:
    'https://image.chewy.com/catalog/cms/logos/attribute-icons/068f118c-588e-7ed1-8000-66989127285b.svg',
  [LoyaltyAsset.PET_HIGH_FIVE_ACCENT_ALT]:
    'https://image.chewy.com/catalog/cms/logos/attribute-icons/068f118c-4e2b-735e-8000-7f3febc06476.svg',
  [LoyaltyAsset.THREE_PLUSES]:
    'https://image.chewy.com/catalog/cms/logos/attribute-icons/0685ee32-3fd1-740f-8000-785fec40ed70.svg',
  [LoyaltyAsset.THREE_PLUSES_ALT]:
    'https://image.chewy.com/catalog/cms/logos/attribute-icons/068e6765-6175-7043-8000-81c713eaac06.svg',
  [LoyaltyAsset.THREE_PLUSES_ALT_CONTRAST]:
    'https://image.chewy.com/catalog/cms/logos/attribute-icons/068f1660-a9e9-7b4c-8000-cfd098d83c0c.svg',
  [LoyaltyAsset.SIGN_UP_HERO_DOG]:
    'https://image.chewy.com/catalog/general/images/moe/068f4464-232b-7ecc-8000-cdb5de7d081b.jpeg',
  [LoyaltyAsset.SIGN_UP_HERO_DOG_ALT]:
    'https://image.chewy.com/catalog/general/images/moe/068f785c-c8fa-79e8-8000-cbee594af09e.jpeg',
  [LoyaltyAsset.SIGN_UP_HERO_CAT]:
    'https://image.chewy.com/catalog/general/images/moe/068f4463-e1dc-75df-8000-e5459b170648.jpeg',
  [LoyaltyAsset.SIGN_UP_HERO_CAT_ALT]:
    'https://image.chewy.com/catalog/general/images/moe/068f785c-d192-7269-8000-88fd10a1e0e6.jpeg',
  [LoyaltyAsset.SIGN_UP_HERO_DOG_HOLIDAY]:
    'https://image.chewy.com/catalog/general/images/moe/068f4520-3671-7036-8000-9fda1dea1033.jpeg',
  [LoyaltyAsset.SIGN_UP_V4_BENEFIT_ICON]:
    'https://image.chewy.com/catalog/cms/logos/attribute-icons/06ab3ba2-dfc5-7968-8000-a9b471cde7fb.svg',
  [LoyaltyAsset.SIGN_UP_V4_PEEK_TAGLINE]:
    'https://image.chewy.com/catalog/cms/logos/attribute-icons/06ac6fba-21af-7c50-8000-929809eeb82d.svg',
  [LoyaltyAsset.SIGN_UP_V4_PEEK_TAGLINE_DARK]:
    'https://image.chewy.com/catalog/cms/logos/attribute-icons/06ac6fba-15ae-7fdc-8000-cfc3c778e4b9.svg',
  [LoyaltyAsset.SIGN_UP_V4_HERO_MOBILE]:
    'https://image.chewy.com/catalog/general/images/moe/06ac6f94-504e-79c5-8000-523089507a0d.jpeg',
  [LoyaltyAsset.SIGN_UP_V4_HERO_MOBILE_DARK]:
    'https://image.chewy.com/catalog/general/images/moe/06ac7bc1-5494-719a-8000-6983bf5089de.jpeg',
  [LoyaltyAsset.SIGN_UP_V4_HERO_TABLET]:
    'https://image.chewy.com/catalog/general/images/moe/06ac6f94-37a6-789e-8000-60f7a42249fd.jpeg',
  [LoyaltyAsset.SIGN_UP_V4_HERO_DESKTOP]:
    'https://image.chewy.com/catalog/general/images/moe/06ac7134-753e-7831-8000-963835543adf.jpeg',
  [LoyaltyAsset.SIGN_UP_V4_HERO_DESKTOP_DARK]:
    'https://image.chewy.com/catalog/general/images/moe/06ac7fd7-e6cb-7e48-8000-20f54a365d95.jpeg',
  [LoyaltyAsset.SIGN_UP_V4_HERO_MOBILE_DOODLE]:
    'https://image.chewy.com/catalog/cms/logos/attribute-icons/06ac6fba-2df0-7efa-8000-1bf56d207262.svg',
  [LoyaltyAsset.SIGN_UP_V4_PEEK_ARROW]:
    'https://image.chewy.com/catalog/cms/logos/attribute-icons/06ac6fba-3b9e-7659-8000-48e6eaf0dd97.svg',
  [LoyaltyAsset.SIGN_UP_V4_PEEK_ARROW_DARK]:
    'https://image.chewy.com/catalog/cms/logos/attribute-icons/06ac6fba-4793-7235-8000-c7fe3accc735.svg',
  [LoyaltyAsset.TESTIMONIAL_CAROUSEL_DOG]:
    'https://image.chewy.com/catalog/cms/logos/attribute-icons/068f5334-3a1a-7c1a-8000-a5e01a7b2424.svg',
  [LoyaltyAsset.SIGN_UP_V4_ROI_FOOD]:
    'https://image.chewy.com/catalog/general/images/moe/06ac6d02-a8cb-721d-8000-1d80872d1359.jpeg',
  [LoyaltyAsset.SIGN_UP_V4_ROI_FOOD_DARK]:
    'https://image.chewy.com/catalog/general/images/moe/06ac6d02-b2ff-73b8-8000-53f79ba13ac3.jpeg',
  [LoyaltyAsset.SIGN_UP_V4_ROI_SHIPPING]:
    'https://image.chewy.com/catalog/general/images/moe/06ac6cf9-0235-7582-8000-f0ae10ea5405.jpeg',
  [LoyaltyAsset.SIGN_UP_V4_ROI_SHIPPING_DARK]:
    'https://image.chewy.com/catalog/general/images/moe/06ac6cf9-218d-7951-8000-04eabe5c5c90.jpeg',
  [LoyaltyAsset.SIGN_UP_V4_ROI_HEALTH]:
    'https://image.chewy.com/catalog/general/images/moe/06ac6d10-1545-7a18-8000-973e39a85da0.jpeg',
  [LoyaltyAsset.SIGN_UP_V4_ROI_HEALTH_DARK]:
    'https://image.chewy.com/catalog/general/images/moe/06ac6d10-2032-772e-8000-092e528d3f4d.jpeg',
  [LoyaltyAsset.SIGN_UP_V4_ROI_RX]:
    'https://image.chewy.com/catalog/general/images/moe/06ac6cf8-f35f-7ec3-8000-c4e78a53b4c3.jpeg',
  [LoyaltyAsset.SIGN_UP_V4_ROI_RX_DARK]:
    'https://image.chewy.com/catalog/general/images/moe/06ac6cf9-17c7-706d-8000-51c36333a925.jpeg',
  [LoyaltyAsset.SIGN_UP_V4_ROI_GENERAL]:
    'https://image.chewy.com/catalog/general/images/moe/06ac6cf9-4dd5-77ca-8000-945f85b796d2.jpeg',
  [LoyaltyAsset.SIGN_UP_V4_ROI_GENERAL_DARK]:
    'https://image.chewy.com/catalog/general/images/moe/06ac6cf9-448c-7a1f-8000-58af92290fb3.jpeg',
  [LoyaltyAsset.SIGN_UP_V4_ROI_CLOUD]:
    'https://image.chewy.com/catalog/cms/logos/attribute-icons/06aad43e-ce97-7cbb-8000-f2a2bbc44e68.svg',
  [LoyaltyAsset.SIGN_UP_V4_ROI_CLOUD_DARK]:
    'https://image.chewy.com/catalog/cms/logos/attribute-icons/06aad43e-db97-788f-8000-c368040003ac.svg',
  [LoyaltyAsset.TESTIMONIAL_CAROUSEL_DOG_ALT]:
    'https://image.chewy.com/catalog/cms/logos/attribute-icons/068f534e-1f86-72d2-8000-5a193a98ba91.svg',
  [LoyaltyAsset.TESTIMONIAL_CAROUSEL_CAT]:
    'https://image.chewy.com/catalog/cms/logos/attribute-icons/068f5334-565c-7628-8000-59bea7118f29.svg',
  [LoyaltyAsset.TESTIMONIAL_CAROUSEL_CAT_ALT]:
    'https://image.chewy.com/catalog/cms/logos/attribute-icons/068f534e-4173-715c-8000-15ff1426ffad.svg',
  [LoyaltyAsset.FAQ_QUOTES_LIGHT]:
    'https://image.chewy.com/catalog/cms/logos/attribute-icons/06aad43e-c114-73b6-8000-5e40572ade64.svg',
  [LoyaltyAsset.FAQ_QUOTES_DARK]:
    'https://image.chewy.com/catalog/cms/logos/attribute-icons/06aad43e-ea49-7e0d-8000-6ccdeb7e417d.svg',
};
